import { forwardRef } from "react"
import { RotateCw } from "lucide-react"
import { IconButton, type IconButtonProps } from "./IconButton"

export interface RefreshButtonProps extends Omit<IconButtonProps, "icon"> {
	/**
	 * Whether the refresh action is in progress
	 */
	isRefreshing?: boolean
}

/**
 * RefreshButton component for triggering data refresh actions.
 * Shows a spinning loader when refreshing. Uses outline variant by default.
 *
 * @example Basic usage
 * ```tsx
 * <RefreshButton onClick={handleRefresh} />
 * ```
 *
 * @example With refresh state
 * ```tsx
 * <RefreshButton isRefreshing={isLoading} onClick={handleRefresh} />
 * ```
 */
export const RefreshButton = forwardRef<HTMLButtonElement, RefreshButtonProps>(
	({ isRefreshing, variant = "outline", ...props }, ref) => {
		return (
			<IconButton ref={ref} icon={RotateCw} loading={isRefreshing} variant={variant} aria-label="Refresh" {...props} />
		)
	}
)

RefreshButton.displayName = "RefreshButton"
